import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, InputNumber, message, Popconfirm, Input } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const MapToolAssociationManager = () => {
  const [associations, setAssociations] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAssociation, setEditingAssociation] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/map_maptool"; // Base URL para SGVMAP_MAP_MAPLYRController

  
  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }
  
  // Obtener todas las asociaciones de capas con mapas
  const fetchAssociations = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: {
          Authorization: getAuthorization(),
        },
      }); // Asume un endpoint para listar todas las asociaciones
      if (!response.ok) throw new Error("Error al obtener las asociaciones capa-mapa");
      const data = await response.json();
      setAssociations(data);
    } catch (error) {
      message.error("Error al obtener la lista de asociaciones capa-mapa");
      console.error(error);
    }
  };

  // Crear o actualizar una asociación
  const handleSaveAssociation = async (values) => {
    const method = editingAssociation ? "PUT" : "POST";
    const url = editingAssociation
      ? `${baseURL}/update`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          Authorization: getAuthorization(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar la asociación");

      message.success(
        editingAssociation
          ? "Asociación actualizada correctamente"
          : "Asociación creada correctamente"
      );
      fetchAssociations();
      setIsModalOpen(false);
      setEditingAssociation(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar la asociación");
      console.error(error);
    }
  };

  // Eliminar una asociación
  const handleDeleteAssociation = async (idMapTool, idRol, idMap) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idMapTool}/${idRol}/${idMap}`, {
        method: "DELETE",
        headers: {
          Authorization: getAuthorization(),
        },
      });
      if (!response.ok) throw new Error("Error al eliminar la asociación");

      message.success("Asociación eliminada correctamente");
      fetchAssociations();
    } catch (error) {
      message.error("Error al eliminar la asociación");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (association) => {
    setEditingAssociation(association);
    form.setFieldsValue(association);
    setIsModalOpen(true);
  };

  // Abrir modal para creación
  const handleCreate = () => {
    setEditingAssociation(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchAssociations();
  }, []);

  const columns = [
    {
      title: "ID Mapa",
      dataIndex: "idMap",
      key: "idMap",
    },
    {
      title: "ID Tool de Mapa",
      dataIndex: "idMapTool",
      key: "idMapTool",
    },
    {
      title: "ID de Rol",
      dataIndex: "idRol",
      key: "idRol",
    },
    {
      title: "Orden",
      dataIndex: "orderPosition",
      key: "orderPosition",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta asociación?"
            onConfirm={() => handleDeleteAssociation(record.idMapTool, record.idRol, record.idMap)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Asociaciones Tool-Mapa</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Asociación
      </Button>
      <Table
        columns={columns}
        dataSource={associations}
        rowKey={(record) => `${record.idMap}-${record.idMapTool}`}
      />

      <Modal
        title={editingAssociation ? "Editar Asociación" : "Crear Asociación"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveAssociation}
          initialValues={{ idMap: "", idMapTool: "", orderPosition: 0 }}
        >
          <Form.Item
            name="idMap"
            label="ID Mapa"
            rules={[{ required: true, message: "Por favor, ingrese el ID del mapa" }]}
          >
            <InputNumber min={0} placeholder="ID del Mapa" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="idMapTool"
            label="ID Tool de Mapa"
            rules={[{ required: true, message: "Por favor, ingrese el ID de la capa de mapa" }]}
          >
            <InputNumber min={0} placeholder="ID de la Tool de Mapa" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="idRol"
            label="ID de Rol"
            rules={[{ required: true, message: "Por favor, ingrese el ID de Rol" }]}
          >
            <InputNumber min={0} placeholder="ID de Rol" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="orderPosition"
            label="Orden"
            rules={[{ required: true, message: "Por favor, ingrese el orden" }]}
          >
            <InputNumber min={0} placeholder="Orden de la Asociación" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="config"
            label="Configuración"
            rules={[{ required: false }]}
          >
            <Input.TextArea placeholder="Configuración (opcional)" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MapToolAssociationManager;
